export default __webpack_public_path__ + "static/media/excel.f9a12401.svg";